<template>
    <div class="animated slideInUp">
<div class="resumeButton"> 

   <center>
           <p style="color: grey; font-size: 20px">Resumes are boring, but if you insist, okay.. </p>
       <a class="waves-effect waves-light btn red" href="https://drive.google.com/file/d/1eAeta0m2HuVWnDoFP_5iaf0zY7fP6x9m/view">
                    Download Resume
                    </a></center>
    
    
    </div>

  

    </div>
</template>

<script>
export default {
    
}
</script>


<style>
.resumeButton{
 margin-top: 40vh;


}
</style>
